import * as actionTypes from "../../constants/actionTypes";
import {
  getOfferExtra,
  getOfferExtraIds,
  getOfferExtras
} from "../../api/offerExtra";
import { OFFER_TYPES } from "../../constants/offerTypes";

const invalidateOfferExtras = () => {
  return {
    type: actionTypes.INVALIDATE_OFFER_EXTRAS_DATA
  };
};

const loadOfferExtra = (clientConfig, offerExtraId) => {
  return {
    type: actionTypes.LOAD_OFFER_EXTRA_DATA,
    promise: getOfferExtra(clientConfig, offerExtraId)
  };
};

const loadOfferExtraPhoneOfferIds = (clientConfig, dataStatus) => {
  return {
    type: actionTypes.LOAD_OFFER_EXTRA_PHONE_OFFER_IDS_DATA,
    promise: getOfferExtraIds(clientConfig, OFFER_TYPES.phoneOffer, dataStatus)
  };
};

const loadOfferExtraPropositionIds = (clientConfig, dataStatus) => {
  return {
    type: actionTypes.LOAD_OFFER_EXTRA_PROPOSITION_IDS_DATA,
    promise: getOfferExtraIds(clientConfig, OFFER_TYPES.proposition, dataStatus)
  };
};

const loadOfferExtraSimOnlyIds = (clientConfig, dataStatus) => {
  return {
    type: actionTypes.LOAD_OFFER_EXTRA_SIM_ONLY_IDS_DATA,
    promise: getOfferExtraIds(clientConfig, OFFER_TYPES.simOnly, dataStatus)
  };
};

const loadOfferExtras = (clientConfig, dataStatus) => {
  return {
    type: actionTypes.LOAD_OFFER_EXTRAS_DATA,
    promise: getOfferExtras(clientConfig, dataStatus)
  };
};

export {
  invalidateOfferExtras,
  loadOfferExtra,
  loadOfferExtraPhoneOfferIds,
  loadOfferExtraPropositionIds,
  loadOfferExtraSimOnlyIds,
  loadOfferExtras
};
